<template>
	<div>
			<div class="container-fluid right_wrapper guard_css">
				<AutomationHeader
					@toggleModal = "toggleModal"
					class="bold_arrow"
				/>
				<div
					v-if="showLoader"
					class="spinner-border"
					style="margin:auto;display:block;margin-top:60px;"
				></div>
				<div v-else-if="!showLoader && automationList.length == 0">
					<NoDataAvailable displayMessage="No Data Is Available" ></NoDataAvailable>
				</div>

				<div v-else>
					<!-- <AutomationList
						 class="table_wrap"
						ref = "automationListData"
						:automationList="automationList"
						:actionList = "actionList"
						:conditionList = "conditionList"
						v-if="automationList.length>0"
					/> -->
					<NewAutomationList
						class="table_wrap"
						ref = "automationListData"
						:automationList="automationList"
						:actionList = "actionList"
						:conditionList = "conditionList"
						v-if="automationList.length>0"
					/>
					<AutomationFooter v-if="actionList.length!=0" class="main_footer_wrap"></AutomationFooter>

				</div>
			</div>
	</div>
</template>

<script>
	import AutomationList from "@/components/Automation2/AutomationList.vue";
	import AutomationHeader from "@/components/Automation2/Automation2Header.vue";
	import AutomationFooter from "@/components/Automation2/AutomationFooter.vue";
	import NoDataAvailable from '@/components/NoDataAvailable.vue'
	import NewAutomationList from "./NewAutomationList"

	export default {
		components: {
			AutomationHeader,
			AutomationList,
			AutomationFooter,
			NoDataAvailable,
			NewAutomationList
		},
		data() {
			return {};
		},
		methods: {
			getAllActions() {
				this.$store
					.dispatch("automation/getAutomations")
					.then(response => {});
			},
			toggleModal(){
				this.$refs['automationListData'].toggleModal()
				this.$refs['automationListData'].enableOther()
			}
		},
		mounted() {
			let vm = this;
			if(this.$route.name =='MyAutomation'){
				this.$store.state.automation.owner = 'Me';
			}
			else if(this.$route.name=='Automation2'){
				this.$store.state.automation.owner = 'All';
			}
			this.$store.dispatch("automation/getAutomations");
			this.$store.dispatch("automation/getConditionList")
			this.$store.dispatch("automation/getActionList")
			//this.$store.dispatch("automation/getActionTypeList");
		},
		computed: {
			showLoader: {
				get() {
					return this.$store.getters["getShowLoader"];
				}
			},
			automationList: {
				get() {
					return this.$store.state.automation.automationList;
				}
			},
			actionList:{
				get() {
					return this.$store.state.automation.actionList;
				}
			},
			conditionList:{
				get() {
					return this.$store.state.automation.conditionList;
				}
			}
		},
		watch:{
			'$route' (to, from){
				this.$store.dispatch("automation/getAutomations");
    }
		}
	};
</script>

<style lang="scss">
</style>
